import React, {Component} from 'react';
import {Provider} from 'mobx-react';
import {Layout} from 'antd';

import SelectedComponent from './components/SelectedComponent'
import LooseLeafs from './components/dashboard/LooseLeafs';
import ArbitratorProfile from './components/dashboard/ArbitratorProfile';
import Profiles from './components/Profiles';
import Books from './components/dashboard/Books';
import MessageFromPartners from './components/dashboard/MessageFromPartners';
import NavigationSider from './components/NavigationSider';
import {appStore} from './stores/AppStore';
import looseLeafStore from './stores/LooseLeafStore'
import looseLeafFormStore from './stores/LooseLeafFormStore'
import {BrowserRouter as Router, Switch, Route, Link} from "react-router-dom";

const {Content} = Layout;

export default class App extends Component {

    render() {

        return (
            <div>
                <Provider
                    appStore={appStore}
                    looseLeafStore={looseLeafStore}
                    looseLeafFormStore={looseLeafFormStore}
                >
                    <Layout style={{minHeight: '100vh'}}>
                        <NavigationSider/>
                        <Layout>
                            <Content>
                                <Router>
                                    <Switch>

                                        <Route path="/looseleafs">
                                            <LooseLeafs/>
                                        </Route>

                                        <Route path="/arbitratorprofile">
                                            <ArbitratorProfile/>
                                        </Route>

                                        <Route path="/profiles">
                                            <Profiles/>
                                        </Route>

                                        <Route path="/books">
                                            <Books/>
                                        </Route>

                                        <Route path="/messagefrompartners">
                                            <MessageFromPartners/>
                                        </Route>

                                        <Route path="/">
                                            <SelectedComponent/>
                                        </Route>
                                    </Switch>
                                </Router>
                            </Content>
                        </Layout>
                    </Layout>
                </Provider>
            </div>
        );
    }
}
